// extracted by mini-css-extract-plugin
export var externalLink = "_6n-0";
export var internalLinkLabel = "_6n-1";